/**
 * Animated shimmer skeleton for business cards.
 * Matches the rough shape & padding of BusinessCard.jsx.
 */
export default function BusinessCardSkeleton() {
  return (
    <div
      className="biz-card overflow-hidden"
      data-testid="business-card-skeleton"
      aria-hidden="true"
    >
      <div className="h-1.5 w-full bg-stone-200" />
      <div className="relative aspect-[16/10] w-full bg-stone-100 lokaso-shimmer" />
      <div className="p-4 space-y-3">
        <div className="h-4 w-2/3 rounded bg-stone-200 lokaso-shimmer" />
        <div className="h-3 w-1/3 rounded bg-stone-200 lokaso-shimmer" />
        <div className="h-3 w-1/2 rounded bg-stone-200 lokaso-shimmer" />
        <div className="flex gap-2 pt-1">
          <div className="h-5 w-12 rounded-full bg-stone-200 lokaso-shimmer" />
          <div className="h-5 w-16 rounded-full bg-stone-200 lokaso-shimmer" />
        </div>
      </div>
    </div>
  );
}
